<template>
  <v-container fluid>
    <template>
      <v-container fluid style="font-size:10px">
        <v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12" class="pt-0 pb-0" dense>
              <v-stepper v-model="e6" alt-labels>
                <v-stepper-header>
                  <v-stepper-step step="1" editable>Educación</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="2" editable>Experiencia</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="3" editable>Conocimiento</v-stepper-step>
                </v-stepper-header>
                <v-stepper-items>
                  <v-stepper-content step="1">
                    <v-row dense>
                      <v-col cols="12" md="12" sm="12" xs="12">
                        <v-data-table
                          :headers="educacion_headers"
                          :items="educacion_items"
                          :search="educacion_search"
                          sort-by="educacion"
                          class="elevation-1"
                        >
                          <template v-slot:top>
                            <v-toolbar flat color="white">
                              <v-toolbar-title class=".body-2">Educación</v-toolbar-title>
                              <v-divider class="mx-4" inset vertical></v-divider>
                              <v-dialog v-model="educacion_dialog" max-width="600px">
                                <template v-slot:activator="{ on }">
                                  <v-chip class="ma-2" color="primary" pill v-on="on">
                                    Nuevo registro
                                    <v-icon right>mdi-plus-circle-outline</v-icon>
                                  </v-chip>
                                </template>
                                <v-card outlined>
                                  <v-card-title>
                                    <v-toolbar-title>Formulario</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-chip
                                      class="ma-2"
                                      color="primary"
                                      outlined
                                      @click="closeEducacion"
                                    >Cancelar</v-chip>
                                    <v-chip
                                      class="ma-2"
                                      color="primary"
                                      pill
                                      @click="saveEducacion"
                                      :disabled="overlay2"
                                    >Guardar</v-chip>
                                  </v-card-title>
                                  <v-divider class="mb-10"></v-divider>
                                  <v-card-text dense>
                                    <v-row dense>
                                      <v-col cols="12" md="12" sm="12" xs="12" dense>
                                        <v-combobox
                                          v-model="educacion_principal"
                                          :items="educaciones_principal"
                                          :filter="customFilterEducacion"
                                          label="Educación principal"
                                          item-text="educacion"
                                          :return-object="true"
                                          @input.native="educacionfinal=$event.srcElement.value"
                                          chips
                                        >
                                          >
                                          <template v-slot:item="data">
                                            <v-list-item-content>
                                              <v-list-item-title v-html="data.item.educacion"></v-list-item-title>
                                              <v-list-item-subtitle v-html="data.item.similares"></v-list-item-subtitle>
                                            </v-list-item-content>
                                          </template>
                                        </v-combobox>
                                      </v-col>
                                      <v-col cols="12 mt-0 mb-0" md="12" sm="12" xs="12" dense>
                                        <v-combobox
                                          v-model="educacion_similares"
                                          :items="educaciones_similares"
                                          label="Educación similar"
                                          :return-object="true"
                                          @input.native="educacionfinalsimilares=educacionfinalsimilares.concat(','+$event.srcElement.value)"
                                          multiple
                                          chips
                                        ></v-combobox>
                                      </v-col>
                                    </v-row>
                                  </v-card-text>
                                </v-card>
                              </v-dialog>
                              <v-spacer></v-spacer>
                              <v-text-field
                                v-model="educacion_search"
                                append-icon="mdi-magnify"
                                label="Busqueda"
                                single-line
                                hide-details
                              ></v-text-field>
                            </v-toolbar>
                            <v-divider></v-divider>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-icon
                              color="primary"
                              @click="editItemEducacion(item)"
                            >mdi-square-edit-outline</v-icon>
                            <v-icon
                              @click="deleteItemEducacion(item)"
                              color="primary"
                            >mdi-delete</v-icon>
                          </template>
                          <template v-slot:no-data>No se tiene educación registrada</template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-stepper-content>
                  <v-stepper-content step="2">
                    <v-row dense class="pa-3">
                      <v-col cols="12" md="12" sm="12" xs="12">
                        <v-data-table
                          :headers="experiencia_headers"
                          :items="experiencia_items"
                          :search="experiencia_search"
                          sort-by="experiencia"
                          class="elevation-1"
                        >
                          <template v-slot:top>
                            <v-toolbar flat color="white">
                              <v-toolbar-title class=".body-2">Experiencias</v-toolbar-title>
                              <v-divider class="mx-4" inset vertical></v-divider>
                              <v-dialog v-model="experiencia_dialog" max-width="600px">
                                <template v-slot:activator="{ on }">
                                  <v-chip class="ma-2" color="primary" pill v-on="on">
                                    Nuevo registro
                                    <v-icon right>mdi-plus-circle-outline</v-icon>
                                  </v-chip>
                                </template>
                                <v-card>
                                  <v-card-title>
                                    <v-toolbar-title>Formulario</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-chip
                                      class="ma-2"
                                      color="primary"
                                      outlined
                                      @click="closeExperiencia"
                                    >Cancelar</v-chip>
                                    <v-chip
                                      class="ma-2"
                                      color="primary"
                                      pill
                                      @click="saveExperiencia"
                                      :disabled="overlay2"
                                    >Guardar</v-chip>
                                  </v-card-title>
                                  <v-divider class="mb-10"></v-divider>
                                  <v-card-text dense>
                                    <v-row dense>
                                      <v-col cols="12" md="12" sm="12" xs="12" dense>
                                        <v-combobox
                                          :items="experiencias_principal"
                                          :filter="customFilterExperiencia"
                                          v-model="experiencia_principal"
                                          item-text="experiencia"
                                          label="Experiencia principal"
                                          :return-object="true"
                                          @input.native="experienciafinal=$event.srcElement.value"
                                          chips
                                        >
                                          <template v-slot:item="data">
                                            <v-list-item-content>
                                              <v-list-item-title v-html="data.item.experiencia"></v-list-item-title>
                                              <v-list-item-subtitle v-html="data.item.similares"></v-list-item-subtitle>
                                            </v-list-item-content>
                                          </template>
                                        </v-combobox>
                                      </v-col>
                                      <v-col cols="12 mt-0 mb-0" md="12" sm="12" xs="12" dense>
                                        <v-combobox
                                          v-model="experiencia_similares"
                                          :items="experiencias_similares"
                                          label="Experiencia similar"
                                          multiple
                                          chips
                                        ></v-combobox>
                                      </v-col>
                                    </v-row>
                                  </v-card-text>
                                </v-card>
                              </v-dialog>
                              <v-spacer></v-spacer>
                              <v-text-field
                                v-model="experiencia_search"
                                append-icon="mdi-magnify"
                                label="Busqueda"
                                single-line
                                hide-details
                              ></v-text-field>
                            </v-toolbar>
                            <v-divider></v-divider>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-icon
                              color="primary"
                              @click="editItemExperiencia(item)"
                            >mdi-square-edit-outline</v-icon>
                            <v-icon
                              @click="deleteItemExperiencia(item)"
                              color="primary"
                            >mdi-delete</v-icon>
                          </template>
                          <template v-slot:no-data>No se tiene experiencia registrada</template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-stepper-content>
                  <v-stepper-content step="3">
                    <v-row dense class="pa-3">
                      <v-col cols="12" md="12" sm="12" xs="12">
                        <v-data-table
                          :headers="conocimiento_headers"
                          :items="conocimiento_items"
                          :search="conocimiento_search"
                          sort-by="conocimiento"
                          class="elevation-1"
                        >
                          <template v-slot:top>
                            <v-toolbar flat color="white">
                              <v-toolbar-title class=".body-2">Conocimientos</v-toolbar-title>
                              <v-divider class="mx-4" inset vertical></v-divider>
                              <v-dialog v-model="conocimiento_dialog" max-width="600px">
                                <template v-slot:activator="{ on }">
                                  <v-chip class="ma-2" color="primary" pill v-on="on">
                                    Nuevo registro
                                    <v-icon right>mdi-plus-circle-outline</v-icon>
                                  </v-chip>
                                </template>
                                <v-card>
                                  <v-card-title>
                                    <v-toolbar-title>Formulario</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-chip
                                      class="ma-2"
                                      color="primary"
                                      outlined
                                      v-on:click="closeConocimiento"
                                    >Cancelar</v-chip>
                                    <v-chip
                                      class="ma-2"
                                      color="primary"
                                      pill
                                      v-on:click="saveConocimiento"
                                      :disabled="overlay2"
                                    >Guardar</v-chip>
                                  </v-card-title>
                                  <v-divider class="mb-10"></v-divider>
                                  <v-card-text dense>
                                    <v-row dense>
                                      <v-col cols="12" md="12" sm="12" xs="12" dense>
                                         <v-combobox
                                          v-model="conocimiento_principal"
                                          :items="conocimientos_principal"
                                          label="Conocimiento"
                                          item-text="conocimiento"
                                          :return-object="true"
                                          @input.native="conocimientofinal=$event.srcElement.value"
                                          chips
                                        ></v-combobox>
                                        </v-col>
                                    </v-row>
                                  </v-card-text>
                                </v-card>
                              </v-dialog>
                              <v-spacer></v-spacer>
                              <v-text-field
                                v-model="conocimiento_search"
                                append-icon="mdi-magnify"
                                label="Busqueda"
                                single-line
                                hide-details
                              ></v-text-field>
                            </v-toolbar>
                            <v-divider></v-divider>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-icon
                              color="primary"
                              v-on:click="editItemConocimiento(item)"
                            >mdi-square-edit-outline</v-icon>
                            <v-icon
                              v-on:click="deleteItemConocimiento(item)"
                              color="primary"
                            >mdi-delete</v-icon>
                          </template>
                          <template v-slot:no-data>No se tiene conocimientos registrados</template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-col>
          </v-row>
        </v-row>
        <div class="text-center ma-2">
          <v-snackbar v-model="snackbar" :color="color">
            <v-icon dark class="pr-5">{{icon}}</v-icon>
            {{error}}
            <v-btn color="white" text @click="snackbar = false">Cerrar</v-btn>
          </v-snackbar>
        </div>
      </v-container>
      <!-- OJO aqui indicamos los headers y los items y el shortby-->
    </template>
    <!-- Este es mi modal para confirmar activacion o desactivadion -->
  </v-container>
</template>
<script>
//Importamos Axios
import axios from "axios";
//Nuestro codigo Vue
export default {
  data: () => ({
    color: "#2A3B4D",
    icon: "mdi-thumb-up",
    overlay2: false,
    error: null,
    educacionfinal: "",
    educacionfinalsimilares: "",
    experienciafinal: null,
    conocimientofinal: null,
    e6: 1,
    snackbar: false,
    overlay: false,
    educacion_headers: [
      { text: "Educación principal", value: "educacion" },
      { text: "Educación similar", value: "similares", sortable: true },
      { text: "Actions", value: "actions", sortable: false, align: "end" }
    ],
    educacion_id: "",
    educacion_items: [],
    educacion_search: "",
    educaciones_principal: [],
    educacion_principal: "",
    educaciones_similares: [],
    educacion_similares: "",

    experiencia_headers: [
      { text: "Experiencia principal", value: "experiencia" },
      { text: "Experiencia similar", value: "similares", sortable: true },
      { text: "Actions", value: "actions", sortable: false, align: "end" }
    ],
    experiencia_id: "",
    experiencia_items: [],
    experiencia_search: "",
    experiencias_principal: [],
    experiencia_principal: "",
    experiencias_similares: [],
    experiencia_similares: "",

    conocimiento_headers: [
      { text: "Conocimiento", value: "conocimiento" },
      { text: "Actions", value: "actions", sortable: false, align: "end"}
    ],
    conocimiento_id: "",
    conocimiento_items: [],
    conocimiento_search: "",
    conocimientos_principal: [],
    conocimiento_principal: "",

    educacion_dialog: false,
    experiencia_dialog: false,
    conocimiento_dialog: false,

    editedIndexEducacion: -1,
    editedIndexExperiencia: -1,
    editedIndexConocimiento: -1,

    valida: 0,
    validamensaje: []
  }),

  watch: {
    overlay(val) {
      val &&
        setTimeout(() => {
          this.overlay = false;
        }, 3000);
    }
  },
  created() {
    this.listarEducacion();
    this.listarExperiencia();
    this.listarConocimiento();
    this.selectEducacionPrincipal();
    this.selectEducacionSimiliares();
    this.selectExperienciaPrincipal();
    this.selectExperienciaSimiliares();
    this.selectConocimiento();
  },
  computed: {
    msg() {
      const selectedRow = this.selected[0];
      return selectedRow
        ? `${selectedRow.firstName} ${selectedRow.lastName}`
        : "no data selected";
    }
  },
  methods: {
    listarEducacion() {
      let me = this;
      axios
        .get("api/MatchEducaciones")
        .then(function(response) {
          me.educacion_items = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    listarExperiencia() {
      let me = this;
      axios
        .get("api/MatchExperiencias")
        .then(function(response) {
          me.experiencia_items = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    listarConocimiento() {
      let me = this;
      axios
        .get("api/MatchConocimientos")
        .then(function(response) {
          me.conocimiento_items = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    selectEducacionPrincipal() {
      let me = this;
      var Array = [];
      axios
        .get("api/MatchEducaciones")
        .then(function(response) {
          me.educaciones_principal = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    selectEducacionSimiliares() {
      let me = this;
      var Array = [];
      var ayuda = "";
      var ArrayMedio = [];
      var ArrayFinal = [];
      axios
        .get("api/MatchEducaciones")
        .then(function(response) {
          Array = response.data;
          var op = Array.map(function(item) {
            return item.similares.toString();
          });
          var Array2 = op.toString().split(",");
          var ArrayFinal = [...new Set(Array2)];
          me.educaciones_similares = ArrayFinal;
        })
        .catch(function(error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    selectExperienciaPrincipal() {
      let me = this;
      var Array = [];
      axios
        .get("api/MatchExperiencias")
        .then(function(response) {
          me.experiencias_principal = response.data;
        })
        .catch(function(error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    selectExperienciaSimiliares() {
      let me = this;
      var Array = [];
      var ayuda = "";
      var ArrayMedio = [];
      var ArrayFinal = [];
      axios
        .get("api/MatchExperiencias")
        .then(function(response) {
          Array = response.data;
          var op = Array.map(function(item) {
            return item.similares.toString();
          });
          var Array2 = op.toString().split(",");
          var ArrayFinal = [...new Set(Array2)];
          me.experiencias_similares = ArrayFinal;
        })
        .catch(function(error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    selectConocimiento() {
      let me = this;
      var Array = [];
      axios
        .get("api/MatchConocimientos")
        .then(function(response) {
          var obj = response.data;
          var res = [];

          for (var i in obj) {
            res.push(obj[i].conocimiento);
          }
          me.conocimientos_principal = res;
          //me.conocimientos_principal = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    closeEducacion() {
      this.educacion_dialog = false;
    },
    closeExperiencia() {
      this.experiencia_dialog = false;
    },
    closeConocimiento() {
      this.conocimiento_dialog = false;
    },
    customFilterExperiencia(item, queryText, itemText) {
      const textOne = item.experiencia.toLowerCase();
      const textTwo = item.similares.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },
    customFilterEducacion(item, queryText, itemText) {
      const textOne = item.educacion.toLowerCase();
      const textTwo = item.similares.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },
    customFilterConocimiento(item, queryText, itemText) {
      const textOne = item.conocimiento.toLowerCase();
      const searchText = queryText.toLowerCase();
      return (
        textOne.indexOf(searchText) > -1
      );
    },
    saveExperiencia() {
      let me = this;
      if (this.editedIndexExperiencia > -1) {
        axios
          .put("/api/MatchExperiencias/" + me.experiencia_id, {
            idmatchexperiencia: me.experiencia_id,
            experiencia: me.experienciafinal.toUpperCase(),
            similares: me.experiencia_similares.toString().toUpperCase()
          })
          .then(function(response) {
            me.color = "#2A3B4D";
            me.icon = "mdi-thumb-up";
            me.error = "Registro exitoso";
            me.snackbar = true;
            me.closeExperiencia();
            me.listarExperiencia();
            me.limpiarExperiencia();
            me.selectExperienciaPrincipal();
            me.selectExperienciaSimiliares();
          })
          .catch(function(error) {
            console.log(error);
            if (error.response.status == 400) {
              me.error = error.response.data.toString();
            }
            me.color = "#E53935";
            me.icon = "mdi-alert";
            me.snackbar = true;
            me.overlay2 = false;
          });
      } else {
        let me = this;
        axios
          .post("/api/MatchExperiencias", {
            experiencia: me.experienciafinal.toUpperCase(),
            similares: me.experiencia_similares.toString().toUpperCase()
          })
          .then(function(response) {
            me.color = "#2A3B4D";
            me.icon = "mdi-thumb-up";
            me.error = "Registro exitoso";
            me.snackbar = true;
            me.closeExperiencia();
            me.listarExperiencia();
            me.limpiarExperiencia();
            me.selectExperienciaPrincipal();
            me.selectExperienciaSimiliares();
          })
          .catch(function(error) {
            console.log(error);
            if (error.response.status == 400) {
              me.error = error.response.data.toString();
            }
            me.color = "#E53935";
            me.icon = "mdi-alert";
            me.snackbar = true;
            me.overlay2 = false;
          });
      }
    },
    deleteItemExperiencia(item) {
      let me = this;
      me.experiencia_id = item.idmatchexperiencia;
      confirm("Esta seguro(a) que desea eliminar este item?") &&
        axios
          .delete("/api/MatchExperiencias/" + me.experiencia_id)
          .then(function(response) {
            console.log("Se elimino");
            me.color = "#2A3B4D";
            me.icon = "mdi-thumb-up";
            me.error = "Eliminación exitosa";
            me.snackbar = true;
            me.snackbar = true;
            me.editedIndexExperiencia = -1;
            //me.e6 = 2;
            me.listarExperiencia();
            me.selectExperienciaPrincipal();
            me.selectExperienciaSimiliares();
          })
          .catch(function(error) {
            console.log(error.response);
          });
      this.overlay = false;
    },
    saveEducacion() {
      let me = this;
      console.log(me.educacionfinalsimilares);
      if (this.editedIndexEducacion > -1) {
        axios
          .put("/api/MatchEducaciones/" + me.educacion_id, {
            idmatcheducacion: me.educacion_id,
            educacion: me.educacionfinal.toUpperCase(),
            similares: me.educacion_similares.toString().toUpperCase()
          })
          .then(function(response) {
            me.color = "#2A3B4D";
            me.icon = "mdi-thumb-up";
            me.error = "Registro exitoso";
            me.snackbar = true;
            me.closeEducacion();
            me.listarEducacion();
            me.limpiarEducacion();
            me.selectEducacionPrincipal();
          })
          .catch(function(error) {
            console.log(error);
            if (error.response.status == 400) {
              me.error = error.response.data.toString();
            }
            me.color = "#E53935";
            me.icon = "mdi-alert";
            me.snackbar = true;
            me.overlay2 = false;
          });
      } else {
        let me = this;
        axios
          .post("/api/MatchEducaciones", {
            educacion: me.educacionfinal.toUpperCase(),
            similares: me.educacion_similares.toString().toUpperCase()
          })
          .then(function(response) {
            me.color = "#2A3B4D";
            me.icon = "mdi-thumb-up";
            me.error = "Registro exitoso";
            me.snackbar = true;
            me.closeEducacion();
            me.listarEducacion();
            me.limpiarEducacion();
            me.selectEducacionPrincipal();
          })
          .catch(function(error) {
            console.log(error);
            if (error.response.status == 400) {
              me.error = error.response.data.toString();
            }
            me.color = "#E53935";
            me.icon = "mdi-alert";
            me.snackbar = true;
            me.overlay2 = false;
          });
      }
    },
    deleteItemConocimiento(item) {
      let me = this;
      me.conocimiento_id = item.idmatchconocimiento;
      confirm("Esta seguro(a) que desea eliminar este item?") &&
        axios
          .delete("/api/MatchConocimientos/" + me.conocimiento_id)
          .then(function(response) {
            console.log("Se elimino");
            me.color = "#2A3B4D";
            me.icon = "mdi-thumb-up";
            me.error = "Eliminación exitosa";
            me.snackbar = true;
            me.snackbar = true;
            me.editedIndexConocimiento = -1;
            //me.e6 = 2;
            me.listarConocimiento();
            me.selectConocimiento();
          })
          .catch(function(error) {
            console.log(error.response);
          });
      this.overlay = false;
    },
   /* trigger () {
    	this.$refs.conocimiento_principal.$el.click();
    },*/
    saveConocimiento() {
      let me = this;
      if (this.editedIndexConocimiento > -1) {
        me.conocimientofinal = me.conocimiento_principal;
        axios
          .put("/api/MatchConocimientos/" + me.conocimiento_id, {
            idmatchconocimiento: me.conocimiento_id,
            conocimiento: me.conocimientofinal.toUpperCase()
          })
          .then(function(response) {
            me.color = "#2A3B4D";
            me.icon = "mdi-thumb-up";
            me.error = "Registro exitoso";
            me.snackbar = true;
            me.closeConocimiento();
            me.listarConocimiento();
            me.limpiarConocimiento();
            me.selectConocimiento();
          })
          .catch(function(error) {
            console.log(error.response);
            if (error.response.status == 400) {
              me.error = error.response.data.toString();
            }
            me.color = "#E53935";
            me.icon = "mdi-alert";
            me.snackbar = true;
            me.overlay2 = false;
          });
      } else {
        let me = this;
        console.log("Crear " + me.conocimientofinal.toString());
        me.conocimientofinal = me.conocimientofinal.toUpperCase();
        axios
          .post("/api/MatchConocimientos", {
            conocimiento: me.conocimientofinal.toUpperCase()
          })
          .then(function(response) {
            me.color = "#2A3B4D";
            me.icon = "mdi-thumb-up";
            me.error = "Registro exitoso";
            me.snackbar = true;
            me.closeConocimiento();
            me.listarConocimiento();
            me.limpiarConocimiento();
            me.selectConocimiento();
          })
          .catch(function(error) {
            console.log(error.response);
            if (error.response.status == 400) {
              me.error = error.response.data.toString();
            }
            me.color = "#E53935";
            me.icon = "mdi-alert";
            me.snackbar = true;
            me.overlay2 = false;
          });
      }
    },

    editItemEducacion(item) {
      this.educacion_id = item.idmatcheducacion;
      this.educacion_principal = item.educacion;
      this.educacion_similares = item.similares.toString().split(",");
      this.editedIndexEducacion = 1;
      this.educacion_dialog = true;
    },
    deleteItemEducacion(item) {
      let me = this;
      me.educacion_id = item.idmatcheducacion;
      confirm("Esta seguro(a) que desea eliminar este item?") &&
        axios
          .delete("/api/MatchEducaciones/" + me.educacion_id)
          .then(function(response) {
            console.log("Se elimino");
            me.color = "#2A3B4D";
            me.icon = "mdi-thumb-up";
            me.error = "Eliminación exitosa";
            me.snackbar = true;
            me.snackbar = true;
            me.editedIndexEducacion = -1;
            //me.e6 = 2;
            me.listarEducacion();
            me.selectEducacionPrincipal();
            me.selectEducacionSimiliares();
          })
          .catch(function(error) {
            console.log(error.response);
          });
      this.overlay = false;
    },
    editItemExperiencia(item) {
      this.experiencia_id = item.idmatchexperiencia;
      this.experiencia_principal = item.experiencia;
      this.experiencia_similares = item.similares.toString().split(",");
      this.editedIndexExperiencia = 1;
      this.experiencia_dialog = true;
    },

    editItemConocimiento(item) {
      this.conocimiento_id = item.idmatchconocimiento;
      this.conocimiento_principal = item.conocimiento;
      this.editedIndexConocimiento = 1;
      this.conocimiento_dialog = true;
    },

    limpiarEducacion() {
      this.educacion_id = "";
      this.educacion_principal = "";
      this.educacion_similares = "";
      this.editedIndexEducacion = -1;
    },

    limpiarExperiencia() {
      this.experiencia_id = "";
      this.experiencia_principal = "";
      this.experiencia_similares = "";
      this.editedIndexExperiencia = -1;
    },

    limpiarConocimiento() {
      this.conocimiento_id = "";
      this.conocimiento_principal = "";
      this.editedIndexConocimiento = -1;
    },

    MostrarSelects() {
      console.log("Mostrar seleccionados" + JSON.stringify(this.selected));
    },

    validar() {
      this.valida = 0;
      this.validamensaje = [];
      //Interesante con este codigo digo si tengo almenos 1 objeto en el array
      if (this.validamensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },

    ActivarDesactivar(item) {
      //La adAccion 1 = Activar y 2 = Desactivar
      this.adModal = 1;
      this.adNombre = item.nombres;
      this.adId = item.idempleado;
      if (item.condicion) {
        this.adAccion = 1;
      } else {
        this.adAccion = 2;
      }
    },

    Activar() {
      let me = this;
      axios
        .put("/api/Empleados/Activar/" + this.adId, {})
        .then(function(response) {
          me.adModal = 0;
          //me.adAccion=1;
          me.adnombre = "";
          me.id = "";
          me.listar();
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    Desactivar() {
      let me = this;
      axios
        .put("/api/Empleados/Desactivar/" + this.adId, {})
        .then(function(response) {
          me.adModal = 0;
          //me.adAccion=1;
          me.adnombre = "";
          me.id = "";
          me.listar();
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    ActivarDesactivarCerrar() {
      this.adModal = 0;
      this.listar();
    }
  }
};
</script>
<style scoped>
* {
  text-transform: none !important;
}

.my-input input {
  text-transform: uppercase;
}
</style>